import React from "react";
import { Helmet } from 'react-helmet-async'; // ✅ Import Helmet
import Navbar from "../components/Navbar";
import AboutSection from "../components/AboutSection";
import FeatureSection from "../components/FeatureSection";
import WorkFlow from "../components/WorkFlow";
import Testimonials from "../components/Testimonials";
import CallToAction from "../components/CallToAction";
import Footer from "../components/Footer";
import { FaMicrochip } from "react-icons/fa"; // Impor ikon IoT dari react-icons
import FloatingWhatsApp from "../components/FloatingWhatsApp"; // Impor Komponen
import PricingSection from "../components/PricingSection"; 
import "../styles/LandingPage.css";

const LandingPage = () => {
    return (
        <div>
            <Helmet> {/* Tambahkan Helmet di sini */}
                <title>Depot Air Cerdas: Solusi IoT untuk Efisiensi & Anti-Curang Depot Air Minum</title>
                <meta name="description" content="Sistem Monitoring Depot Air Minum, Tingkatkan efisiensi & cegah kecurangan di depot air minum Anda dengan sistem IoT cerdas. Pantau stok air, galon terjual, dan lokasi pengiriman real-time. Solusi terdepan untuk manajemen depot air modern dan peningkatan profitabilitas." />
                <meta name="keywords" content="Sistem Monitoring Depot Air Minum, IoT depot air, smart water depot, monitoring galon, anti curang depot, manajemen depot air, sistem air minum, IoT monitoring, analitik bisnis, keamanan data IoT, pelacakan GPS galon, depot air isi ulang, efisiensi depot" />
                <link rel="canonical" href="https://depotaircerdas.com/" /> {/* Canonical URL untuk halaman utama */}
                
                {/* Open Graph / Twitter Card Meta Tags untuk halaman utama */}
                <meta property="og:title" content="Depot Air Cerdas: Solusi IoT untuk Efisiensi & Anti-Curang Depot Air Minum" />
                <meta property="og:description" content="Tingkatkan efisiensi & cegah kecurangan di depot air minum Anda dengan sistem IoT cerdas. Pantau stok air, galon terjual, dan lokasi pengiriman real-time. Solusi terdepan untuk manajemen depot air modern dan peningkatan profitabilitas." />
                <meta property="og:url" content="https://depotaircerdas.com/" />
                <meta property="og:image" content="https://depotaircerdas.com/images/og-image-depot-air-cerdas.jpg" /> {/* Pastikan gambar ini ada di folder public/images */}
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="id_ID" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Depot Air Cerdas: Solusi IoT untuk Efisiensi & Anti-Curang Depot Air Minum" />
                <meta name="twitter:description" content="Tingkatkan efisiensi & cegah kecurangan di depot air minum Anda dengan sistem IoT cerdas. Pantau stok air, galon terjual, dan lokasi pengiriman real-time. Solusi terdepan untuk manajemen depot air modern dan peningkatan profitabilitas." />
                <meta name="twitter:image" content="https://depotaircerdas.com/images/twitter-image-depot-air-cerdas.jpg" /> {/* Pastikan gambar ini ada di folder public/images */}
            </Helmet>

            <Navbar />
            <header id="home" className="hero">
                <div className="hero-content">
                    <h1>Solusi Cerdas IoT untuk Depot Air Minum</h1>
                    <p>
                        Pantau volume air, galon terjual, dan pengiriman dengan teknologi IoT. 
                        Hindari kecurangan dan tingkatkan efisiensi bisnis Anda!
                    </p>
                    <a href="/login">
                        <button className="btn-primary">Coba Gratis Sekarang</button>
                    </a>
                </div>
                {/* Gantilah gambar dengan ikon */}
                <div className="hero-icon">
                    <FaMicrochip className="iot-icon"/>
                    <span className="iot-text">IoT Monitoring</span>
                </div>
            </header>
            <AboutSection />  
            <FeatureSection />
            <WorkFlow />
            <Testimonials />
            <PricingSection />
            <CallToAction />
            <Footer />
            <FloatingWhatsApp />  {/* Tambahkan Komponen WhatsApp */}
        </div>
    );
};

export default LandingPage;